const DAYS_OF_WEEK_SHORT = {
  0: 'Sun',
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
};

const MONTHS_SHORT = {
  0: 'Jan',
  1: 'Feb',
  2: 'Mar',
  3: 'Apr',
  4: 'May',
  5: 'Jun',
  6: 'Jul',
  7: 'Aug',
  8: 'Sep',
  9: 'Oct',
  10: 'Nov',
  11: 'Dec',
};

export function formatDate(date, showYear = false) {
  const dayOfWeek = date.getDay();
  const dayOfWeekText = DAYS_OF_WEEK_SHORT[dayOfWeek];
  const month = date.getMonth();
  const monthText = MONTHS_SHORT[month];
  const dateText = date.getDate();
  const year = date.getFullYear();

  return `${dayOfWeekText}, ${monthText} ${dateText} ${showYear ? year : ''}`;
};